<div class="d-flex flex-column h-100">
  <mat-toolbar class="mat-elevation-z8">
    <button mat-icon-button *ngIf="sidenav.mode === 'over'" (click)="sidenav.toggle()">
      <mat-icon *ngIf="!sidenav.opened">menu</mat-icon>
      <mat-icon *ngIf="sidenav.opened">close</mat-icon>
    </button>
    <button mat-icon-button *ngIf="sidenav.mode === 'side'" (click)="onClickToggleMenu()">
      <mat-icon>menu</mat-icon>
    </button>
    {{appTitle}}
    <app-tree-select *ngIf="sidenav && sidenav.mode === 'side'" [dataService]="organizationService" [isExpanded]="true"></app-tree-select>
    <span class="spacer"></span>
    <div *ngIf="sidenav.mode === 'side'">
      <small>{{user.username}}</small>
      <button mat-icon-button (click)="onClickChangePassword()">
        <mat-icon>key</mat-icon>
      </button>
    </div>
    <button mat-icon-button (click)="onClickLogout()">
      <mat-icon>exit_to_app</mat-icon>
    </button>
  </mat-toolbar>
  <div *ngIf="isOver()" class="company-selector-wrapper">
    <app-tree-select [dataService]="organizationService" [isExpanded]="true"></app-tree-select>
  </div>
  <mat-sidenav-container autosize>
    <mat-sidenav #sidenav="matSidenav" (mouseenter)="mouseenter()" (mouseleave)="mouseleave()">
      <mat-nav-list *ngFor="let nav of navigation">
        <ng-template [ngIf]="!nav.isExpandable">
          <mat-list-item class="parent" [ngClass]="{'disabled' : isDisabled(nav)}"
                         routerLinkActive="sidenav-item-active"
                         routerLink="{{nav.routerLink}}"
                         (click)="onClickMenuItem(nav)">
            <span *ngIf="isExpanded || isMenuTextShown">{{nav.name}}</span>
            <mat-icon mat-list-icon *ngIf="nav.icon">{{nav.icon}}</mat-icon>
          </mat-list-item>
        </ng-template>
        <ng-template [ngIf]="nav.isExpandable">
          <a mat-list-item (click)="toggleMenu(nav.name)" [ngClass]="{'disabled' : isDisabled(nav)}">
            <mat-icon mat-list-icon>{{nav.icon}}</mat-icon>
            <span *ngIf="isExpanded || isMenuTextShown">{{nav.name}}</span>
            <mat-icon *ngIf="openedMenu !== nav.name">chevron_right</mat-icon>
            <mat-icon *ngIf="openedMenu === nav.name ">expand_more</mat-icon>
          </a>
          <mat-nav-list class="sidenav-submenu" *ngIf="openedMenu === nav.name">
            <mat-list-item *ngFor="let sub of nav.subMenuItems" class="ml-3" routerLinkActive="sidenav-item-active"
                           [ngClass]="{'disabled' : isDisabled(sub)}"
                           routerLink="{{sub.routerLink}}"
                           (click)="onClickMenuItem(sub)">
              <span *ngIf="isExpanded || isMenuTextShown">{{sub.name}}</span>
              <mat-icon mat-list-icon *ngIf="sub.icon">{{sub.icon}}</mat-icon>
            </mat-list-item>
          </mat-nav-list>
        </ng-template>
      </mat-nav-list>
      <mat-nav-list>
        <mat-list-item (click)="openHelpDialog()">
          <mat-icon mat-list-icon>help</mat-icon>
          <span *ngIf="isExpanded || isMenuTextShown">{{help}}</span>
        </mat-list-item>
      </mat-nav-list>
      <mat-nav-list *ngIf="sidenav.mode === 'over'">
        <mat-list-item class="parent">
          <mat-icon>face</mat-icon>&nbsp;<small>{{user.username}}</small>
        </mat-list-item>
        <mat-list-item class="parent">
          <button mat-icon-button (click)="onClickChangePassword()">
            <mat-icon>key</mat-icon>
            Change password
          </button>
        </mat-list-item>
        <mat-list-item class="parent">
          <button mat-icon-button (click)="onClickLogout()">
            <mat-icon>exit_to_app</mat-icon>
            Logout
          </button>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

